<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.name')}}
                <el-form-item prop="name">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.name.value"
                    maxlength="50"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.prioridad')}}
                <el-form-item prop="prioridad">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.prioridad.value"
                    min="0"
                    max="9999999999"
                    type="number"
                  />
                </el-form-item>
              </label>
            </div>
            
             <div>
              <AccessibleElSelect
                v-model="form.activo.value"
                prop="activo"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="rulesbygroup"
              >
                <template slot="label">{{$t('companies.active')}}</template>
              </AccessibleElSelect>
            </div>
            
             <div>
              <AccessibleElSelect
                v-model="form.DetenerEjecucion.value"
                prop="DetenerEjecucion"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="rulesbygroup"
              >
                <template slot="label">{{$t('groups.detener_ejecucion')}}</template>
              </AccessibleElSelect>
            </div>

             <div>
              <AccessibleElSelect
                v-model="form.EnDescarga.value"
                prop="EnDescarga"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="rulesbygroup"
              >
                <template slot="label">{{$t('configurations.en_descarga')}}</template>
              </AccessibleElSelect>
            </div>

            
             <div>
              <AccessibleElSelect
                v-model="form.automatic_download.value"
                prop="automatic_download"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="rulesbygroup"
              >
                <template slot="label">{{$t('companies.group_download')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.nombreGrupo.value"
                prop="nombreGrupo"
                :options="gruposForAccessibleSelect"
                :withFormItem="true"
                :group="true"
                id-prefix="rulesbygroup"
              >
                <template slot="label">{{$t('notificationFilter.group')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.nombreGrupoPropietario.value"
                prop="nombreGrupoPropietario"
                :options="gruposOwnerForAccessibleSelect"
                :withFormItem="true"
                :group="true"
                id-prefix="rulesbygroup"
              >
                <template slot="label">{{$t('notificationFilter.group_owner')}}</template>
              </AccessibleElSelect>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getGroupsNames } from '@/services/configurations/groups/getGroupsNames'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'grouprules',
      isOpen: this.panelOpen,
      links: [],
      form: {
        id: { label: i18n.t('configurations.id'), value: '' },
        name: { label: i18n.t('configurations.name'), value: '' },
        prioridad: { label: i18n.t('configurations.prioridad'), value: '' },
        activo: { label: i18n.t('companies.active'), value: '' },
        DetenerEjecucion: { label: i18n.t('groups.detener_ejecucion'), value: '' },
        EnDescarga: { label: i18n.t('configurations.en_descarga'), value: '' },
        automatic_download: { label: 'Descarga automática', value: '' },
        nombreGrupo: { label: 'Grupo', value: '' },
        nombreGrupoPropietario: { label: 'GrupoPropietario', value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      clientes: [],
      valuesNombresGrupos: [],
    }
  },

  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    const gruposUsuario = await getGroupsNames()
    if (gruposUsuario.blnError) {
      this.doFeedback(gruposUsuario.msgError + ' [Código de error: ' + gruposUsuario.codError + ']')
    } else {
      this.valuesNombresGrupos = gruposUsuario.Respuesta
    }
  },
  computed: {
    valuesForAccessibleSelect: function () {
      return this.values.map(item => ({
        id: item.value,
        name: item.label
      }))
    },
    gruposForAccessibleSelect: function () {
      const flatOptions = []
      this.listaGroupsGrouping.forEach(group => {
        group.options.forEach(option => {
          flatOptions.push({
            id: option.value,
            name: `${group.label} - ${option.label}`,
            value: option.value
          })
        })
      })
      return flatOptions
    },
    gruposOwnerForAccessibleSelect: function () {
      const flatOptions = []
      this.listaGroupsGroupingOwner.forEach(group => {
        group.options.forEach(option => {
          flatOptions.push({
            id: option.value,
            name: `${group.label} - ${option.label}`,
            value: option.value
          })
        })
      })
      return flatOptions
    },
    listaGroupsGrouping () {
      if (this.valuesNombresGrupos.length > 0) {
        const options = []
        this.valuesNombresGrupos.forEach(x => {
          if (options.filter(y => y.label === x.Tipo).length === 0) {
            options.push(
              { label: x.Tipo, options: [] }
            )
          }
        })
        this.valuesNombresGrupos.forEach(x => {
          const index = options.map(x => x.label).indexOf(x.Tipo)
          options[index].options.push(
            {
              value: x.Nombre,
              label: x.Nombre,
            }
          )
        })
        return options
      }
      return []
    },
    listaGroupsGroupingOwner () {
      return this.listaGroupsGrouping.filter(x => x.label !== 'Reparto')
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.id.value = _temp.id !== undefined && _temp.id.value !== '' ? _temp.id.value : ''
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.prioridad.value = _temp.prioridad !== undefined && _temp.prioridad.value !== '' ? _temp.prioridad.value : ''
        this.form.activo.value = _temp.activo !== undefined && _temp.activo.value !== '' ? _temp.activo.value : ''
        this.form.DetenerEjecucion.value = _temp.DetenerEjecucion !== undefined && _temp.DetenerEjecucion.value !== '' ? _temp.DetenerEjecucion.value : ''
        this.form.EnDescarga.value = _temp.EnDescarga !== undefined && _temp.EnDescarga.value !== '' ? _temp.EnDescarga.value : ''
        this.form.automatic_download.value = _temp.automatic_download !== undefined && _temp.automatic_download.value !== '' ? _temp.automatic_download.value : ''
        this.form.nombreGrupo.value = _temp.nombreGrupo !== undefined && _temp.nombreGrupo.value !== '' ? _temp.nombreGrupo.value : ''
        this.form.nombreGrupoPropietario.value = _temp.nombreGrupoPropietario !== undefined && _temp.nombreGrupoPropietario.value !== '' ? _temp.nombreGrupoPropietario.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        id: { label: i18n.t('configurations.id'), value: '' },
        name: { label: i18n.t('configurations.name'), value: '' },
        prioridad: { label: i18n.t('configurations.prioridad'), value: '' },
        activo: { label: i18n.t('companies.active'), value: '' },
        DetenerEjecucion: { label: i18n.t('groups.detener_ejecucion'), value: '' },
        EnDescarga: { label: i18n.t('configurations.en_descarga'), value: '' },
        automatic_download: { label: 'Descarga automática', value: '' },
        nombreGrupo: { label: 'Grupo', value: '' },
        nombreGrupoPropietario: { label: 'Grupo propietario', value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    querySearch: function (queryString, cb) {
      const links = this.links
      const results = queryString ? links.filter(this.createFilter(queryString)) : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelect: function (item) {
      // console.log(item)
    },
    handleSelectTag: function (item) {
      // console.log('handleSelectTag', item)
      this.form.nombreTag.value = item.id
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    handleSelectRole: function (item) {
      this.form.role.value = item.id
    },
    handleSelectTipoAuth: function (item) {
      this.form.tipoAuth.value = item.id
    }
  }
}
</script>

<style lang="scss" scoped></style>
